import { LbvSearchQueryResponse, SearchParameter } from 'types/search.type'

export const getMedusaSearchParameters = async (
  locale: string
): Promise<SearchParameter> => {
  const res = await fetch(
    `/api/search/parameters?locale=${encodeURIComponent(locale)}`
  )

  if (!res.ok) {
    throw new Error('Failed to fetch search parameters')
  }

  return res.json()
}

export const medusaSearchByQuery = async (
  locale: string,
  searchParameters: SearchParameter[]
): Promise<LbvSearchQueryResponse> => {
  const res = await fetch('/api/search', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      locale,
      searchParameters,
    }),
  })

  if (!res.ok) {
    throw new Error('Failed to fetch search results from internal API')
  }

  return await res.json()
}

export const medusaSearchByQueryCount = async (
  locale: string,
  searchParameters: SearchParameter[]
): Promise<any> => {
  const res = await fetch('/api/search/count', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ locale, searchParameters }),
  })

  if (!res.ok) {
    throw new Error('Failed to fetch search count')
  }

  return res.json()
}

export const filterListToQuery = (filters: SearchParameter[]): string => {
  const params: string[] = []

  filters.forEach((filter) => {
    const [filterKey, filterData] = Object.entries(filter)[0]

    filterData.values.forEach((value) => {
      params.push(
        `${encodeURIComponent(filterKey)}=${encodeURIComponent(value.key)}`
      )
    })
  })

  return params.join('&')
}
